import { Divider } from "@material-ui/core";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Tab from "@mui/material/Tab";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAttributes, GetUserId, GetUserInfo } from "../../../_utilities/getUserInfo";
import DynamicTable from "../../../components/DynamicTable/DynamicTable";
// pages
import { Box, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import * as _ser from "../../../_redux/_services/ApplicantsSlice";
import * as _props from "../../../_redux/_services/JobPostingSlice";
import { customFieldsAsync } from "../../../_redux/_services/UserManagerSlice";
import {
  setHighlightFilter,
  resetHighlightFilter,
} from "../../../_redux/HighlightSlice";
import { updateSnackbar } from "../../../_redux/SnackbarSlice";
import Loading from "../../../components/Loader/Loading";
import RightSideBar from "../../../components/Rightsidebar/RightSideBar";
import SendSms from "../../../components/SendSms/SendSms";
import { AddProjectFooterIllustration } from "../../../Icons/AddProjectFooterIllustration";
import { DashboardPlusicon } from "../../../Icons/DashboardPlusicon";
import { SendSMSillu } from "../../../Icons/SendSMSillu";
import AddToProject from "../../Projects/AddApplicantsToProject/AddApplicantsToProject";
import AddApplicantAssociatedJobs from "../ApplicantsAssociatedJobs/AddApplicantAssociatedJobs";
import ApplicantsManualUploadPopup from "./ApplicantsManualUploadPopup";
import { ApplicantsReadExcelData } from "./ApplicantsReadExcelData";
import { ApplicantsRenderData } from "./ApplicantsRenderData";
import "./ApplicantsTable.css";
import DuplicateApplicantsManualUploadPopup from "./DuplicateApplicantsManualUploadPopup";
import ViewToggle from "../../../components/ViewToggle";
import AdvancedSearch from "../../../components/AdvancedSearch/AdvancedSearch";
import FloatingMenu from "../../../components/FloatingMenu/FloatingMenu";
import { ApplicantTablefloatingMenuOptions } from "../../../constants/floatingMenuConstants";
import WarningPopup from "../../../components/WarningPopup/WarningPopup";

const initalState = { data: null, message: "", isloader: true };
const initalFilter = {
  jobtitle: "",
  yearsExperienceMin: "",
  yearsExperienceMax: "",
  boolean: "",
  keyword: "",
  recruiterId: "",
};

const TableApplicants = () => {
  const [users, setUsers] = useState([]);
  const [config, setConfig] = useState(configuration);
  const [filterValue, setFilterValue] = useState("");
  const [isRightSidePannel, setIsRightSidePannel] = useState(false);
  const [isUploadExcelPannel, setIsUploadExcelPannel] = useState(false);
  const [isBulkuploadResponse, setIsBulkuploadResponse] = useState(false);
  const [bulkUploadMessage, setBulkUploadMessage] = useState({});
  const [isAdvancePannel, setIsAdvancePannel] = useState(false);
  const [advanceSearchlist, setAdvanceSearchlist] = useState([]);
  const [skillsObj, setSkillsObj] = useState([]);
  const [titleObj, setTitleObj] = useState([]);
  const [advancedSearch, setAdvancedSearch] = useState(null);
  const [filterObj, setFilterObj] = useState(
    JSON.parse(JSON.stringify(initalFilter)),
  );
  const [isDisableBtn, setIsDisableBtn] = useState(true);
  const [manualApplicatsConfirmPopup, setManualApplicatsConfirmPopup] =
    useState(false);
  const [updateProfileWithNewResume, setUpdateProfileWithNewResume] =
    useState(null);
  const [duplicateApplicatsConfirmPopup, setDuplicateApplicatsConfirmPopup] =
    useState(false);
  const [
    twoDuplicateApplicatsConfirmPopup,
    setTwoDuplicateApplicatsConfirmPopup,
  ] = useState(false);
  const [skipId, setSkipId] = useState(null);
  const [skipName, setSkipName] = useState(null);
  const [statusObj, setStatusObj] = useState([]);
  const [footerImg, setFooterImg] = useState(false);
  const [isSendsms, setIsSendsms] = useState(false);
  const [smsCandidates, setSmsCandidates] = useState([]);
  const [isAddToProject, setIsAddToProject] = useState(false);
  const [selectedApplicants, setSelectedApplicants] = useState([]);
  const [locationValue, setLocationValue] = useState({
    id: 0,
    location: "",
    type: "",
  });
  const [locationRadius, setLocationRadius] = useState(100);
  const [loading, setLoading] = useState(false);
  const [uploadedDocuments, setUploadedDocuments] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [pannelobj, setPannelobj] = useState({
    title: "",
    description: "",
    bgImage: "",
    navigateTo: "",
  });
  const [selectedJob, setSelectedJob] = useState({ jobId: 0, jobCode: "" });
  const [searchablefields, setSearchablefields] = useState([]);
  const [locationsOptions, setLocationsOptions] = useState([]);
  const [isAssociateJob, setIsAssociateJob] = useState(false);
  const [isAssociate, setIsAssociate] = useState(null);
  const [fieldOptions, setFieldOptions] = useState({});
  const [openFloatingMenu, setOpenFloatingMenu] = useState(false);
  const customFieldsData = useSelector((state) => state.CustomFields.data);
  const [sourceId, setSourceId] = useState(0);
  const [defaultFile, setDefaultFile] = useState(null);
  const [isBulk, setIsBulk] = useState(false);
  const [showLandingPage, setShowLandingPage] = useState(false);
  const [recruiterObj, setRecruiterObj] = useState([]);
  const [advancedSearchObj, setAdvancedSearchObj] = useState(null);
  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
  const [warningPopupDetails, setWarningPopupDetails] = useState({
    title: "",
    title1: "",
    btnName: "",
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();

  // const { jobtitle: jobTitleKeyswords, skills: skillsKeyswords } = useSelector(
  //   (state) => state.Highlight
  // );
  const advSearchParams = useSelector(
    (state) => state.Highlight.initialParams
  );
  const recruiterList = useSelector(
    (state) => state.GetManagerTeamlead.recruiter,
  );

  const storedTheme = JSON.parse(localStorage.getItem("themeSettings")) || "";

  useEffect(() => {
    async function init() {
      const userId = await GetUserId();
      dispatch(customFieldsAsync(userId));
    }
    init();
  }, []);

  useEffect(() => {
    async function getRecruiter() {
      if (recruiterList?.length > 0) {
        const data = JSON.parse(JSON.stringify(recruiterList));
        let newArray = [];
        data.forEach((list) => {
          let obj = {
            id: list.id.toString(),
            name: `${list.firstName} ${list.lastName}`,
            emailId: list.emailId,
          };
          newArray.push(obj);
        });
        setRecruiterObj(newArray);
      } else {
        let userId = await GetUserId();
        dispatch(_props.getManagerTeamleadAsync(" ", userId));
      }
    }
    getRecruiter();
  }, []);

  useEffect(() => {
    if (recruiterList?.length > 0) {
      const data = JSON.parse(JSON.stringify(recruiterList));
      let newArray = [];
      data.forEach((list) => {
        let obj = {
          id: list.id.toString(),
          name: `${list.firstName} ${list.lastName}`,
          emailId: list.emailId,
        };
        newArray.push(obj);
      });
      setRecruiterObj(newArray);
    }
  }, [recruiterList]);

  useEffect(() => {
    if (customFieldsData && customFieldsData.length > 0) {
      const data = JSON.parse(JSON.stringify(customFieldsData));
      let customSearchableFields = data.filter(
        (x) => x.moduleId.toString() === "2" && x.searchableField === 1,
      ); // && x.fieldName !== "Candidate status"
      if (customSearchableFields.length > 0) {
        let array = [...advanceSearchModel];
        customSearchableFields.forEach((list) => {
          let obj = {};
          list.customValues = JSON.parse(list.customValues);
          if (list) {
            obj["id"] = array.length + 1;
            obj["displayName"] = list.fieldName;
            obj["name"] = list.fieldName;
            obj["isActive"] = false;
            obj["helperText"] = list.helperText
              ? list.helperText
              : "Custom field";
            obj["type"] =
              list.dataType === "Text box"
                ? "text1"
                : list.dataType === "Multi select"
                  ? "options"
                  : list.fieldName === "Candidate status"
                    ? "autoCompleteMulti"
                    : list.fieldName === "Source"
                      ? "autoCompleteSingle"
                      : list.dataType === "Single select"
                        ? "singleSelect"
                        : "";
          }
          array.push(obj);
        });
        setAdvanceSearchlist(array);
      } else {
        setAdvanceSearchlist(advanceSearchModel);
      }
      setSearchablefields(customSearchableFields);
      // dispatch(customFieldsStartReducer({}));
    } else {
      setAdvanceSearchlist(advanceSearchModel);
    }
  }, [customFieldsData]);

  useEffect(() => {
    localStorage.removeItem("OverwriteEditObj");
    FetchData({ current: config.currentPage, offset: users.length + 1 });
    // Initialize user info and config
    const userInfo = GetUserInfo();
    const updatedConfig = userInfo
      ? (() => {
        const newConfig = { ...config };
        let updatedInlineOptions = ApplicantTablefloatingMenuOptions?.inline;

        if (userInfo[0]?.systemroles === "Standard User") {
          newConfig.isDropdownActions = false;
          updatedInlineOptions = updatedInlineOptions.filter(
            (a) => a.label !== "Delete",
          );
        }
        if (
          userInfo[0]?.projectStatus === null ||
          userInfo[0]?.projectStatus === 0
        ) {
          updatedInlineOptions = updatedInlineOptions.filter(
            (a) => a.action !== "Add to Project",
          );
        }
        // Remove Send SMS if integrations are not enabled
        const integrations = userInfo[0]?.integrations
          ? JSON.parse(userInfo[0].integrations)
          : [];
        const ringCentralIntegration = integrations.find(
          (i) =>
            i.attribute_5 === "Ring Central" &&
            i.attribute_3?.includes("Messages"),
        );

        if (
          !integrations ||
          !ringCentralIntegration ||
          ringCentralIntegration.active === null
        ) {
          updatedInlineOptions = updatedInlineOptions.filter(
            (a) => a.action !== "Send SMS",
          );
        }
        // newConfig.menuOptions = updatedMenuOptions;
        newConfig.inlineOptions = updatedInlineOptions;
        return newConfig;
      })()
      : configuration;

    setConfig(updatedConfig);

    // Reset document upload reducer
    dispatch(_ser.uploadDocumentsStartReducer(initalState));

    // Helper to apply keyword filters
    const applyKeywordFilters = (keywords) => {
      if (Object.keys(keywords).length > 0) {
        setIsAdvancePannel(true);
        handleApplyAdvancedSearch(keywords, {}, 1);
      } else {
        setIsAdvancePannel(false);
      }
    };

    applyKeywordFilters(advSearchParams);
  }, []);

  const applicantsData = useSelector((state) => state.GetListApplicants.data);
  const bulkUploadResumeData = useSelector(
    (store) => store.BulkUploadResume.data,
  );

  useEffect(() => {
    if (bulkUploadResumeData) {
      setIsBulkuploadResponse(true);
      setBulkUploadMessage(bulkUploadResumeData);
      dispatch(_ser.bulkUploadResumeStartReducer(initalState));
    }
  }, [bulkUploadResumeData]);

  const FetchData = async (obj) => {
    setUsers([]);
    let configure = JSON.parse(JSON.stringify(config));
    configure.currentPage = obj.current;
    configure.totalRecordsCount = 0;
    setConfig(configure);
    dispatch(_ser.getListApplicantsAsync(config.limitData, obj.offset));
  };

  useEffect(() => {
    if (applicantsData !== null) {
      const myData = JSON.parse(JSON.stringify(applicantsData));
      setUsers([]);
      if (myData?.rows?.length > 0) {
        myData.rows.forEach((e) => {
          e["isChecked"] = false;
          e.userFirstName = e.userFirstName ? e.userFirstName : " ";
          e.userLastName = e.userLastName ? e.userLastName : " ";
          e["createdBy"] = e.userFirstName + " " + e.userLastName;
          e["ApplicantName"] = e.firstName + " " + e.lastName;
        });
        let configure = JSON.parse(JSON.stringify(config));
        configure.totalRecords = myData.total_count / config.limitData;
        configure.totalRecordsCount = myData?.total_count;
        setConfig(configure);
        setUsers(myData.rows);
        localStorage.removeItem("OverwriteEditObj")
        dispatch(_ser.getListApplicantsStartReducer(initalState));
      }
    }
  }, [applicantsData]);

  // for dynamic component received props
  const onReceiveActionHandler = async (type, object, url) => {
    if (
      object?.length === 0 &&
      (type === "confirmDel" ||
        type === "Add to Project" ||
        type === "Send SMS")
    ) {
      dispatch(
        updateSnackbar({
          message: "No record selected",
          type: "error",
        }),
      );
      return;
    }
    if (type === "confirmDel") {
      setWarningPopupDetails({
        title: "Are you sure you want to delete this Applicant?",
        title1: "This action cannot be undone.",
        btnName: "Delete",
      });
      setOpenDeleteConfirm(true);
    } else if (type === "download") {
      alert("download option is not implemented!");
    } else if (type === "pagination") {
      if (filterValue !== "") {
        getSearchResult(object, true, url, type);
      } else if (advancedSearch && Object.keys(advancedSearch).length > 0) {
        setConfig({ ...config, currentPage: object.current });
        handleApplyAdvancedSearch(
          advancedSearch,
          advancedSearchObj || {},
          object.current,
        );
      } else {
        FetchData(object);
      }
    } else if (type === "searchResult") {
      // let isPaging = object.current > 1 ? true : false;
      if (
        filterValue !== "" ||
        (object.keyword !== "" && object.keyword !== undefined)
      ) {
        object.offset = object.offset ? object.offset : 1;
        setFilterValue(object.keyword);
        getSearchResult(object, true, url, type);
      } else if (object.limitData === undefined) {
        object.limitData = config.limitData;
        getSearchResult(object, false, url, type);
      }
    } else if (type === "cancelSearchResult") {
      if (advancedSearch && Object.keys(advancedSearch).length > 0) {
        setConfig({ ...config, currentPage: 1 });
        setFilterValue("");
        handleApplyAdvancedSearch(
          advancedSearch,
          advancedSearchObj || {},
          1,
        );
      } else {
        setFilterValue("");
        let obj1 = { current: 1, offset: 1 };
        FetchData(obj1);
      }
    } else if (type === "newApplicants") {
      setIsRightSidePannel(object);
      dispatch(_ser.setSelectedJobDetailsStartReducer(initalState));
      setOpenFloatingMenu(false);
    } else if (type === "pageRange") {
      setConfig({ ...config, limitData: (config.limitData = object) });
      // let obj1 = { current: config.currentPage, offset: config.currentPage !== 1 ? (config.currentPage - 1) * config.limitData + 1 : config.currentPage, limit: config.limitData };
      let obj1 = { current: 1, offset: 1, limit: config.limitData };
      if (filterValue !== "") {
        getSearchResult(obj1, true, url, type);
      } else if (advancedSearch && Object.keys(advancedSearch).length > 0) {
        // setConfig({ ...config, currentPage: object.current });
        handleApplyAdvancedSearch(advancedSearch, advancedSearchObj || {}, 1);
      } else {
        FetchData(obj1);
      }
    } else if (type === "Send SMS") {
      setIsSendsms(true);
      setSmsCandidates(object);
    } else if (type === "Add to Project") {
      setSelectedApplicants(object);
      setIsAddToProject(true);
    } else if (type === "selectedRows") {
      setSelectedApplicants(object);
    } else if (type === "uploadExcel") {
      setIsUploadExcelPannel(true);
    } else if (type === "createManually") {
      navigate("/ats/layout/applicants/create", {
        state: { createManually: true },
      });
    }
  };

  const DelApplicantscode = useSelector((state) => state.DeleteApplicants.data);
  const { data: UploadDocCode, docId: UploadDocId } = useSelector((state) => state.UploadDocuments);

  const DeleteRecords = async (object) => {
    let ids;
    if (typeof object === "object" && object.length > 0) {
      ids = object.map((x) => x.id.toString());
    } else {
      ids = [object.toString()];
    }
    const userId = await GetUserId();
    let obj = { ids: ids, Customerid: userId };
    dispatch(_ser.deleteApplicantsAsync(obj));
  };

  useEffect(() => {
    if (DelApplicantscode === 200) {
      let obj1 = {
        current: config.currentPage,
        offset:
          config.currentPage !== 1
            ? (config.currentPage - 1) * config.limitData + 1
            : config.currentPage,
      };
      FetchData(obj1);
      setFilterValue("");
      dispatch(_ser.deleteApplicantsStartReducer(initalState));
    }
  }, [DelApplicantscode, config.currentPage, config.limitData]);

  const handleConfirmDelete = () => {
    if (selectedApplicants.length === users.length && config.currentPage > 1) {
      let modifyConfig = { ...config };
      modifyConfig.currentPage = config.currentPage - 1;
      modifyConfig.offset = (modifyConfig.currentPage - 1) * config.limitData + 1;
      setConfig(modifyConfig);
    }
    DeleteRecords(selectedApplicants);
    setOpenDeleteConfirm(false);
  };

  const handleCancelDelete = () => {
    setOpenDeleteConfirm(false);
  };

  const getSearchResult = async (object, paging, url, type) => {
    setUsers([]);
    if (paging === true) {
      if (filterValue === "") {
        setFilterValue(object.keyword);
      }
      // else if (filterValue !== "" && filterValue !== object.keyword) {
      //   setFilterValue(object.keyword);
      // }
      SearchResultWithPaging(object, url);
    } else {
      if (url !== undefined) {
        // setFilterValue(object.keyword);
      } else {
        setFilterValue(object.keyword);
      }
      if (object.current === undefined) {
        object["current"] = 1;
        object["limitData"] = 20;
        url["offset"] = 1;
        url["limit"] = 20;
      } else {
        url["offset"] = object.offset;
        url["limit"] = object.limit;
      }
      SearchResultWithoutPaging(object, url);
    }
  };

  // useEffect(() => {
  //   async function FetchData() {
  //     const userInfo = await getUserDetails();
  //     dispatch(updateAuth(userInfo));
  //   }
  //   FetchData();
  //   // eslint-disable-next-line
  // }, []);

  const SearchApplicantsWithoutPagingData = useSelector(
    (state) => state.SearchApplicantsWithoutPaging.data,
  );

  const SearchResultWithoutPaging = async (object, url) => {
    let configure = JSON.parse(JSON.stringify(config));
    configure.currentPage = object.current;
    configure.totalRecordsCount = 0;
    setConfig(configure);
    dispatch(_ser.searchApplicantsWithoutPagingAsync(object, url));
  };

  useEffect(() => {
    if (
      SearchApplicantsWithoutPagingData &&
      (SearchApplicantsWithoutPagingData.length > 0 ||
        SearchApplicantsWithoutPagingData.rows?.length > 0)
    ) {
      const applicantsWithoutPagingData = JSON.parse(
        JSON.stringify(SearchApplicantsWithoutPagingData),
      );
      let myData =
        applicantsWithoutPagingData?.rows || applicantsWithoutPagingData;
      const total_count =
        applicantsWithoutPagingData?.total_count ||
        applicantsWithoutPagingData[0]?.total_count;
      myData.forEach((e) => {
        e["isChecked"] = false;
        e.userFirstName = e.userFirstName ? e.userFirstName : "-";
        e.userLastName = e.userLastName ? e.userLastName : "-";
        e["createdBy"] = e.userFirstName + " " + e.userLastName;
        e["ApplicantName"] = e.firstName + " " + e.lastName;
      });
      let configure = JSON.parse(JSON.stringify(config));
      configure.totalRecords = total_count / config.limitData; //myData[0]?.totalCount ? myData[0].totalCount :
      configure.totalRecordsCount = total_count;
      setConfig(configure);
      setUsers(myData.slice(0, config.limitData));
      dispatch(_ser.searchApplicantsWithoutPagingStartReducer(initalState));
    } else if (
      SearchApplicantsWithoutPagingData ||
      SearchApplicantsWithoutPagingData?.rows
    ) {
      //&& SearchApplicantsWithoutPagingData.length === 0
      let configure = JSON.parse(JSON.stringify(config));
      configure.totalRecords = 0;
      configure.currentPage = 1;
      configure.totalRecordsCount = 0;
      setConfig(configure);
      setUsers([]);
      dispatch(_ser.searchApplicantsWithoutPagingStartReducer(initalState));
    }
  }, [SearchApplicantsWithoutPagingData, dispatch, config]);

  const SearchApplicantsWithPagingData = useSelector(
    (state) => state.SearchApplicantsWithPaging.data,
  );

  const selectedJobDetails = useSelector(
    (state) => state.SetSelectedJobDetails.data,
  );

  const SearchResultWithPaging = async (object, url) => {
    let value = object.keyword ? object.keyword : filterValue; //filterValue? filterValue : object.keyword;
    dispatch(
      _ser.searchApplicantsWithPagingAsync(
        config.limitData,
        object.offset,
        value,
        url,
      ),
    );
    let configure = JSON.parse(JSON.stringify(config));
    configure.currentPage = object.current;
    configure.totalRecordsCount = 0;
    setConfig(configure);
  };

  useEffect(() => {
    if (
      SearchApplicantsWithPagingData &&
      (SearchApplicantsWithPagingData.length > 0 ||
        SearchApplicantsWithPagingData?.rows?.length > 0)
    ) {
      const applicantsWithPagingData = JSON.parse(
        JSON.stringify(SearchApplicantsWithPagingData),
      );
      let myData = applicantsWithPagingData?.rows || applicantsWithPagingData;
      const total_count = applicantsWithPagingData?.total_count; // || applicantsWithPagingData[0].total_count;
      myData.forEach((e) => {
        e["isChecked"] = false;
        e.userFirstName = e.userFirstName ? e.userFirstName : "-";
        e.userLastName = e.userLastName ? e.userLastName : "-";
        e["createdBy"] = e.userFirstName + " " + e.userLastName;
        e["ApplicantName"] = e.firstName + " " + e.lastName;
      });
      let configure = JSON.parse(JSON.stringify(config));
      configure.totalRecords = total_count / config.limitData;
      configure.totalRecordsCount = total_count;
      setConfig(configure);
      setUsers(myData.slice(0, config.limitData));
      dispatch(_ser.searchApplicantsWithPagingStartReducer(initalState));
    } else if (
      SearchApplicantsWithPagingData?.rows ||
      SearchApplicantsWithPagingData
    ) {
      //&& SearchApplicantsWithPagingData.length === 0
      let configure = JSON.parse(JSON.stringify(config));
      configure.totalRecords = 0;
      configure.currentPage = 1;
      configure.totalRecordsCount = 0;
      setConfig(configure);
      setUsers([]);
      dispatch(_ser.searchApplicantsWithPagingStartReducer(initalState));
    }
  }, [SearchApplicantsWithPagingData]);

  const onReceivePropsHandler = (pannel, load, bool) => {
    setIsBulkuploadResponse(load !== "getFetch" ? pannel : false);
    setIsUploadExcelPannel(pannel);
    setOpenFloatingMenu(pannel);
    setFooterImg(bool);
    setIsSendsms(pannel);
    setIsAddToProject(pannel);
    setIsAssociateJob(pannel);
    setIsRightSidePannel(pannel);
    setShowLandingPage(false);
    setSelectedApplicants([]);
    if (load === "close") {
      setUploadedDocuments([]);
      setIsAssociate(null);
    }
    if (load === "Back") {
      setIsRightSidePannel(true);
      setUploadedDocuments(uploadedDocuments);
    }
    if (load?.type === "AssociateJob") {
      setIsAssociateJob(true);
      setIsAssociate(false);
      setUploadedDocuments(load?.data || []);
      setIsBulk(load?.isBulk);
    } else if (load === "linkNewApplicantToJob") {
      setIsRightSidePannel(true);
    } else if (load?.type === "associateJobSave") {
      setIsAssociate(true);
      setShowLandingPage(true);
    }
    let obj1 = { current: 1, offset: 1 };
    FetchData(obj1);
    setFilterValue('');
    if (!pannel) {
      setSmsCandidates([]);
    }
  };

  useEffect(() => {
    if (
      selectedJobDetails &&
      selectedJobDetails.length > 0 &&
      Object.keys(uploadedDocuments).length > 0
    ) {
      setSelectedJob({
        jobId: selectedJobDetails[0].id,
        jobCode: selectedJobDetails[0].jobCode,
      });
      setIsLoading(true);
      let formData = new FormData();
      const { imgData, userInfo, sourced, userDetails, GetUserId } =
        uploadedDocuments;
      for (let i = 0; i < imgData?.length; i++) {
        formData.append("Resume", imgData[i]);
      }
      formData.append("customerId", GetUserId);
      formData.append("userId", userInfo?.userId);
      if (imgData?.length === 1) {
        dispatch(_ser.uploadResumeAsync(formData, true));
      } else {
        formData.append("userFirstName", userInfo.firstName);
        formData.append("userLastName", userInfo.lastName);
        formData.append("email", userInfo.email);
        formData.append("resumesourceId", sourced.id ? sourced.id : "");
        formData.append("resumesource", sourced.name ? sourced.name : "");
        formData.append("submittedBy", userInfo?.id);
        formData.append("DbUserId", userInfo?.id);
        formData.append("source", "ATS");
        dispatch(
          _ser.bulkUploadResumeAsync(formData, true, {
            jobId: selectedJobDetails[0].id,
            jobCode: selectedJobDetails[0].jobCode,
          }),
        );
      }
    }
  }, [selectedJobDetails]);

  const bulkUploadResumeCode = useSelector(
    (store) => store.BulkUploadResume.code,
  );
  const uploadResumeData = useSelector((store) => store.UploadResume.data);
  const duplicateResume = useSelector((store) => store.UploadResume.code);
  const updateResumeData = useSelector((store) => store.UploadResume);
  const isDuplicats = useSelector((store) => store.UploadResume.isDuplicats);

  useEffect(() => {
    if (bulkUploadResumeCode === 200 && isAssociate === false) {
      setIsLoading(false);
      dispatch(_ser.bulkUploadResumeStartReducer(initalState));
    } else {
      setIsLoading(false);
    }
  }, [bulkUploadResumeCode]);

  useEffect(() => {
    if (
      uploadResumeData !== null &&
      uploadedDocuments?.sourced !== "" &&
      uploadedDocuments?.imgData?.length !== 0 &&
      isAssociate !== null
    ) {
      setIsLoading(false);
      let json = JSON.parse(JSON.stringify(uploadResumeData[0]));
      navigate("/ats/layout/applicants/create", {
        state: {
          applicant: json,
          sourceId: uploadedDocuments?.sourced,
          uploadfile: uploadedDocuments?.imgData[0],
          isAssociate: selectedJob,
          isduplicate: false,
          showLandingPage: showLandingPage,
        },
      }); //props.isduplicate
      dispatch(_ser.uploadResumeStartReducer(initalState));
    }
  }, [uploadResumeData]);

  useEffect(() => {
    if (
      duplicateResume === 500 &&
      updateResumeData.updatedata !== null &&
      isAssociate !== null
    ) {
      setIsLoading(false);
      dispatch(_ser.uploadResumeStartReducer(initalState));
      let obj = {
        data: updateResumeData.updatedata[0],
        message: updateResumeData.message,
        id: updateResumeData.id,
        oldApplicantName: updateResumeData.oldApplicantName,
      };
      onManualPopup(
        false,
        uploadedDocuments?.sourced,
        uploadedDocuments?.imgData ? uploadedDocuments?.imgData[0] : null,
        obj,
      );
    }
    if (duplicateResume === 500 && isAssociate === false) {
      setIsLoading(false);
      dispatch(_ser.uploadResumeStartReducer(initalState));
    } else if (duplicateResume === 400 && isAssociate !== null) {
      setIsLoading(false);
      dispatch(_ser.uploadResumeStartReducer(initalState));
      onManualPopup(
        true,
        uploadedDocuments?.sourced,
        uploadedDocuments?.imgData[0],
        null,
      );
    }
    if (isDuplicats !== null && isAssociate !== null) {
      setIsLoading(false);
      onManualPopup(false, null, null, { data: isDuplicats });
    }
  }, [duplicateResume, updateResumeData, isDuplicats]);

  const onAdvanceSearchPannel = (type) => {
    if (type === "close") {
      setIsAdvancePannel(false);
    } else {
      setIsAdvancePannel(true);
    }
  };

  const SelectOptionsHandler = (obj) => {
    let options = searchablefields.filter((x) => x.fieldName === obj.name);
    if (options.length > 0) {
      setFieldOptions((prev) => ({
        ...prev,
        [obj.name]: options[0]?.customValues,
      }));
    }
  };

  const onApplyAdFilterHandler = (obj) => {
    let params = {},
      generateURL = "",
      titleObject = titleObj,
      skillsObject = skillsObj;
    if (titleObject.length > 0) {
      params["jobTitle"] = titleObject.join(",");
    }
    if (skillsObject.length > 0) {
      params["skills"] = skillsObject.join(",");
    }
    if (statusObj) {
      let custom = [];
      let Keys = Object.keys(statusObj);
      Keys.forEach((list) => {
        if (
          statusObj[list]?.length > 0 &&
          list !== "Candidate status" &&
          list !== "Source"
        ) {
          let obj = {
            key:
              list === "Document type"
                ? "documentType"
                : `${list.replace(/ +/g, " ")}`,
            value: `${statusObj[list]}`,
          };
          custom.push(obj);
        } else if (list === "Candidate status" && statusObj[list].length > 0) {
          params[`${list.replace(/ +/g, "")}`] = statusObj[list];
        } else if (list === "Source" && statusObj[list]) {
          params[`${list.replace(/ +/g, " ")}`] =
            typeof statusObj[list] === "string"
              ? statusObj[list]
              : statusObj[list][0];
        }
      });
      if (custom.length > 0) {
        params["custom"] = custom;
      }
    }
    if (filterObj.yearsExperienceMin !== "") {
      params["yearsExperienceMin"] = filterObj.yearsExperienceMin;
    }
    if (filterObj.yearsExperienceMax !== "") {
      params["yearsExperienceMax"] = filterObj.yearsExperienceMax;
    }
    if (filterObj?.boolean !== "") {
      params["boolean"] = filterObj.boolean;
    }
    if (filterObj?.keyword !== "") {
      params["keyword"] = filterObj.keyword;
    }
    if (locationValue.id !== 0) {
      params["locationId"] = locationValue.id;
      params["radius"] = locationRadius;
      params["type"] = locationValue?.type;
    }
    if (filterObj?.recruiterId && filterObj?.recruiterId !== "") {
      params["recruiterId"] = parseInt(filterObj.recruiterId);
    }
    if (Object.keys(params).length > 0) {
      onReceiveActionHandler("searchResult", obj, params);
    } else {
      dispatch(
        updateSnackbar({
          type: "error",
          message: "Select atleast one field to filter",
        }),
      );
    }
  };

  useEffect(() => {
    if (
      titleObj.length > 0 ||
      skillsObj.length > 0 ||
      Object.keys(statusObj).length > 0 ||
      filterObj.yearsExperienceMax !== "" ||
      filterObj.yearsExperienceMax !== "" ||
      filterObj.boolean !== "" ||
      filterObj.keyword !== ""
    ) {
      setIsDisableBtn(false);
    } else {
      setIsDisableBtn(true);
    }
  }, [skillsObj, filterObj, statusObj]);

  const onManualuploadHandler = () => {
    let json = {
      Applicants: {
        firstName: "",
        lastName: "",
        phone: "",
        emailId: "",
        alternateContactNumber: "",
        resumesourceId: sourceId,
      },
      totalExperience: null,
      linkedIn: "",
      educationDetails: [],
      workExp: [],
      skillDetails: [],
      certification: [],
      identifier: "",
      customFields: JSON.stringify([]),
      jobDescription: "",
      source: sourceId,
      id: 0,
    };
    navigate("/ats/layout/applicants/create", {
      state: {
        applicant: json,
        sourceId: sourceId,
        uploadfile: defaultFile,
        isAssociate: isAssociate !== null ? selectedJob : null,
        isduplicate: false,
        isManual: true,
      },
    });
  };

  const onManualPopup = (isPopup, sourceId, file, obj) => {
    if (sourceId !== null && file !== null) {
      setManualApplicatsConfirmPopup(isPopup);
      setSourceId(sourceId);
      setDefaultFile(file);
      if (obj !== null) {
        setSkipId(obj.id);
        let json = {
          Applicants: obj.data.Applicants,
          totalExperience: obj.data.totalExperience
            ? obj.data.totalExperience
            : null,
          linkedIn: obj.data.linkedIn ? obj.data.linkedIn : "",
          educationDetails: obj.data.educationDetails
            ? obj.data.educationDetails
            : [],
          workExp: obj.data.workExperiences ? obj.data.workExperiences : [],
          skillDetails: obj.data.skillDetails ? obj.data.skillDetails : [],
          certification: obj.data.certifications ? obj.data.certifications : [],
          identifier: obj.data.identifier ? obj.data.identifier : "",
          jobDescription: "",
          customFields: JSON.stringify([]),
          source: sourceId,
          id: obj.id,
          oldApplicantName: obj.oldApplicantName ? obj.oldApplicantName : "",
          Resume: file,
          locationData: obj.data.locationData ? obj.data.locationData : [],
        };
        setUpdateProfileWithNewResume(json);
        setDuplicateApplicatsConfirmPopup(true);
        setSourceId(sourceId);
      }
    } else {
      setTwoDuplicateApplicatsConfirmPopup(true);
      setSkipId(obj.data.id);
      setSkipName(obj.data.name);
    }
  };

  useEffect(() => {
    const associatedToJobs = async () => {
      if (UploadDocCode === 200 && skipId && UploadDocId && selectedJobDetails) {
        let userInfo = await GetUserInfo();
        let userId = await getAttributes();
        let data = {
          id: skipId,
          jobCode: selectedJobDetails[0].jobCode,
          docId: UploadDocId,
          firstName: userId[0].firstName,
          lastName: userId[0].lastName,
          portalassociatedJobs: "associatedJobs",
          status: "Associated",
          source: "ATS",
          submittedBy: userInfo[0].userId,
          userId: userId[0].userId,
        };
        let jobs = [];
        if (selectedJobDetails && selectedJobDetails.length > 0) {
          selectedJobDetails.forEach((job) => {
            let obj = {};
            obj["jobId"] = job.id;
            obj["jobCode"] = job.jobCode;
            jobs.push(obj);
          });
        }
        data["jobs"] = jobs.length > 0 ? jobs : [];
        dispatch(_ser.addAssociatedjobsAsync(skipId, data, "posting"));
      }
      if (UploadDocCode === 200 && skipId) {
        navigate(`/ats/layout/applicants/documents/${skipId}`);
        dispatch(_ser.uploadDocumentsStartReducer(initalState));
      }
    }
    associatedToJobs();
  }, [UploadDocCode, UploadDocId, skipId, selectedJobDetails]);

  const countriesData = useSelector((state) => state.CountriesListByValue.data);

  useEffect(() => {
    if (countriesData && countriesData.length > 0) {
      setLoading(false);
      setLocationsOptions(countriesData);
      dispatch(_ser.getCountriesListByValueStartReducer(initalState));
    } else if (countriesData && countriesData.length === 0) {
      setLocationsOptions([]);
      setLoading(false);
    }
  }, [countriesData, dispatch]);

  const handleCloseAdvancedSearch = () => {
    setIsAdvancePannel(false);
  };

  const handleApplyAdvancedSearch = (params, object, page = 1) => {
    if (Object.keys(params).length > 0) {
      setAdvancedSearch(params);
      if (page === 1) {
        setAdvancedSearchObj(object || null);
      }
    }
    const searchParams = {
      offset: page !== 1 ? (page - 1) * config.limitData + 1 : 1,
      limit: config.limitData,
      ...params,
    };
    let configure = JSON.parse(JSON.stringify(config));
    configure.currentPage = page;
    configure.totalRecords = 0;
    configure.totalRecordsCount = 0;
    setConfig(configure);
    const { location, type, ...filteredParams } = params;
    setFilterValue("");
    dispatch(
      _ser.searchApplicantsWithoutPagingAsync(
        { ...filteredParams, type },
        searchParams,
      ),
    );
    const generateObj = Object.entries(params).reduce((acc, [key, value]) => {
      if (key === "recruiterId") return acc; // ✅ skip this key
      if (key === "Candidatestatus" && Array.isArray(value)) {
        acc[key] = value.map((val) => ({
          id: val,
          internal: val ? val.replace(/_/g, " ") : "",
        }));
      } else if (key === "custom" && Array.isArray(value)) {
        value.forEach((item, index) => {
          acc[`custom${index + 1}`] = item?.value ?? "";
        });
      } else {
        acc[key] = Array.isArray(value) ? value.join(",") : value;
      }
      return acc;
    }, {});

    dispatch(
      setHighlightFilter({
        advSearch:
          {
            ...generateObj,
            ...(object?.recruiter && { recruiter: object.recruiter }),
            location,
          } || {},
        params: params,
      }),
    );
  };

  const handleClearAdvancedFilters = () => {
    dispatch(resetHighlightFilter());
    setAdvancedSearch(null);
    setAdvancedSearchObj(null);
    if (filterValue !== "" && filterValue.length >= 2) {
      dispatch(
        _ser.searchApplicantsWithPagingAsync(config.limitData, 1, filterValue),
      );
    } else {
      let modifyConfig = { ...config };
      modifyConfig.currentPage = 1;
      modifyConfig.offset = 1;
      setConfig(modifyConfig);
      dispatch(_ser.getListApplicantsAsync(modifyConfig.limitData, 1));
    }
  };

  return (
    <div style={{ marginTop: "80px", marginBottom: "60px" }}>
      <div
        style={{
          background: "#fff",
          padding: !isAdvancePannel ? "22px 47px 47px" : "22px 47px 47px 0",
        }}
      >
        <div
          className={
            Boolean(config.isDropdownActions) || isAdvancePannel
              ? "advanceSearchbtn"
              : "advanceSearchbtn1 advanceSearchbtn"
          }
          style={{ position: Boolean(config.isDropdownActions) || isAdvancePannel ? "absolute" : 'relative' }} >
          <button
            style={{
              marginLeft: !isAdvancePannel ? "0" : "31px",
              position: !isAdvancePannel ? "absolute" : "fixed",
            }}
            onClick={() => onAdvanceSearchPannel("open")}
          >
            <img
              src={process.env.PUBLIC_URL + "/assests/panel.svg"}
              alt="advanced search btn"
            />
            Advanced search
          </button>
        </div>
        {/* for dynamic Table */}
        <div className={Boolean(config.isDropdownActions) || isAdvancePannel ? "d-flex table_section_advance_search" : "d-flex"}>
          <AdvancedSearch
            isOpen={isAdvancePannel}
            onClose={handleCloseAdvancedSearch}
            onApplyFilter={handleApplyAdvancedSearch}
            customFieldsData={customFieldsData}
            recruiterList={recruiterList}
            storedTheme={storedTheme}
            onClearFilters={handleClearAdvancedFilters}
          />
          <div style={{ width: !isAdvancePannel ? "100%" : "80%" }}>
            {/* <section className="floatingMenu">
              <div
                className={`fab ${openFloatingMenu ? "active" : ""}`}
                onClick={() => setOpenFloatingMenu(!openFloatingMenu)}
              >
                <DashboardPlusicon width={35} height={36} />
              </div>
              {openFloatingMenu && (
                <svg
                  id="fab-expend-bg"
                  data-name="Group 42457"
                  width="358.132"
                  height="139.141"
                  viewBox="0 0 358.132 139.141"
                >
                  <g
                    id="Group_42456"
                    data-name="Group 42456"
                    clip-path="url(#clip-path)"
                  >
                    <path
                      id="Path_64807"
                      data-name="Path 64807"
                      d="M280.816,1.6c-15.768-7.017-28.049,9.8-71.184,35.069-15.015,8.795-36.5,37.578-42.072,53.847-5.588,16.3-19.819,32.653-54.428,32.653H0v15.97H358.132V81.926c0-3.047-1.047-7.71-2.79-12.97-7.559-22.8-52.578-57.587-74.526-67.354"
                      fill={storedTheme?.secondaryColor}
                    />
                  </g>
                </svg>
              )}
              {openFloatingMenu && (
                <div className="menu">
                  <button
                    onClick={(e) => {
                      onReceiveActionHandler("newApplicants", true);
                    }}
                  >
                    Upload Resume
                  </button>
                  <button
                    onClick={(e) => {
                      setIsUploadExcelPannel(true);
                    }}
                  >
                    Upload Excel
                  </button>
                  <button
                    onClick={(e) => {
                      navigate("/ats/layout/applicants/create", {
                        state: { createManually: true },
                      });
                    }}
                  >
                    Create Manually
                  </button>
                </div>
              )}
            </section> */}
            <div id="applicantstable-floating-menu">
              <FloatingMenu
                config={config}
                floatingMenuOptions={ApplicantTablefloatingMenuOptions}
                onReceiveActionHandler={(type, isSelected) =>
                  onReceiveActionHandler(type, selectedApplicants)
                }
                storedTheme={storedTheme}
              />
              <WarningPopup
                dialogTitle={'Confirm Deletion'}
                open={openDeleteConfirm}
                handleClose={handleCancelDelete}
                handleConfirm={handleConfirmDelete}
                details={warningPopupDetails}
              />
            </div>
            <div id="applicantstable-dynamic-table">
              {users && users.length === 0 && (
                <DynamicTable
                  config={config}
                  data={users}
                  colmns={columnsData}
                  actionDropdown={
                    config.actionsDropdownData
                      ? config.actionsDropdownData
                      : actionsDropdownData
                  }
                  filterValue={filterValue}
                  searchKeyWord="Search by Code, Name, E-mail, Contact"
                  actions={actionsList}
                  addModel={{}}
                  noDataText="No Applicants Found"
                  onReceiveActionProps={(type, obj) =>
                    onReceiveActionHandler(type, obj)
                  }
                />
              )}
              {users && users.length > 0 && (
                <DynamicTable
                  config={config}
                  data={users}
                  colmns={columnsData}
                  actionDropdown={
                    config.actionsDropdownData
                      ? config.actionsDropdownData
                      : actionsDropdownData
                  }
                  filterValue={filterValue}
                  searchKeyWord="Search by Code, Name, E-mail, Contact"
                  actions={actionsList}
                  addModel={{}}
                  nodataText="No Applicants Found"
                  onReceiveActionProps={(type, obj) =>
                    onReceiveActionHandler(type, obj)
                  }
                />
              )}
            </div>
            <div style={{ display: "flex", flexDirection: "row-reverse" }}>
              <ViewToggle view={"table"} type={"applicant"} />
            </div>
          </div>
        </div>

        {isRightSidePannel ? (
          <div className="applicantUploadpannel">
            <RightSideBar
              componentData={
                <ApplicantsRenderData
                  onReceivechildProps={onReceivePropsHandler}
                  isAssociate={null}
                  onManualPopup={onManualPopup}
                  input={uploadedDocuments}
                />
              }
              componentLayout={!footerImg ? pannelobj1 : pannelobj2}
              isFooter={false}
              footerImg={<SendSMSillu />}
              onReceiveProps={onReceivePropsHandler}
            />
          </div>
        ) : isUploadExcelPannel ? (
          <RightSideBar
            componentData={
              <ApplicantsReadExcelData
                onReceivechildProps={onReceivePropsHandler}
              />
            }
            componentLayout={!footerImg ? pannelobj1 : pannelobj2}
            footerImg={<SendSMSillu />}
            onReceiveProps={onReceivePropsHandler}
          />
        ) : isBulkuploadResponse ? (
          <div id="bulkUploadResults">
            <RightSideBar
              componentData={
                <ComponentRenderData
                  data={bulkUploadMessage}
                  onReceivechildProps={onReceivePropsHandler}
                />
              }
              componentLayout={bulkResponseObj}
              onReceiveProps={onReceivePropsHandler}
            />
          </div>
        ) : isSendsms ? (
          <div id="sendSms">
            <RightSideBar
              componentData={
                <SendSms
                  data={smsCandidates}
                  onReceivechildProps={onReceivePropsHandler}
                />
              }
              componentLayout={smsObj}
              onReceiveProps={onReceivePropsHandler}
            />
          </div>
        ) : isAddToProject ? (
          <div id="addToProject" className="rightsidebarbtn">
            <RightSideBar
              componentData={
                <AddToProject
                  applicantIds={selectedApplicants}
                  onReceivechildProps={onReceivePropsHandler}
                />
              }
              componentLayout={addToProjectObj}
              footerImg={<AddProjectFooterIllustration />}
              onReceiveProps={onReceivePropsHandler}
            />
          </div>
        ) : isAssociateJob ? (
          <AddApplicantAssociatedJobs
            componentType={"AssociatedJobs"}
            isRightSidePannel={isAssociateJob}
            AccociatedJobSeekerList={[]}
            onPropsReceive={onReceivePropsHandler}
            questionsData={[]}
            getData={null} //getData
            pannelobj={pannelobj}
            isAssociate={isAssociate}
            isBulk={isBulk}
          />
        ) : (
          ""
        )}
        {/* Manual Upload popup */}
        {manualApplicatsConfirmPopup === true && (
          <section className="customModal">
            <div className="customModalDiv">
              <h1 className="modal-header">Error</h1>
              <div className="modal-body">
                <p>
                  We are currently facing a technical glitch. Please select to
                  upload resume manually.
                </p>
                <div className="modalActionBtns">
                  <Button
                    type="button"
                    className="cancelBtn"
                    style={{ marginRight: "20px" }}
                    onClick={() => {
                      setManualApplicatsConfirmPopup(false);
                      setUploadedDocuments([]);
                    }}
                  >
                    Cancel
                  </Button>
                </div>
                <Button
                  type="button"
                  variant="contained"
                  className="saveBtn"
                  sx={{ width: "125px !important" }}
                  onClick={onManualuploadHandler}
                >
                  Upload Manually
                </Button>
              </div>
            </div>
          </section>
        )}

        {duplicateApplicatsConfirmPopup === true && (
          <ApplicantsManualUploadPopup
            skipId={skipId}
            isAssociatedApplicant={false} // isAssociate ? isAssociate : false
            updateProfileWithNewResume={updateProfileWithNewResume}
            sourceId={sourceId}
            defaultFile={defaultFile}
            setDuplicateApplicatsConfirmPopup={() => {
              dispatch(_ser.uploadResumeStartReducer(initalState));
              setUploadedDocuments([]);
              setUpdateProfileWithNewResume(null);
              setIsAssociate(null);
              setDuplicateApplicatsConfirmPopup(false);
              // setSkipId(null);
            }}
          />
        )}

        {twoDuplicateApplicatsConfirmPopup === true && (
          <DuplicateApplicantsManualUploadPopup
            skipId={skipId}
            skipName={skipName}
            setTwoDuplicateApplicatsConfirmPopup={() => {
              setTwoDuplicateApplicatsConfirmPopup(false);
              dispatch(_ser.uploadResumeStartReducer(initalState));
              setSkipId(null);
              setSkipName(null);
              setUploadedDocuments([]);
            }}
          />
        )}
      </div>
      {isLoading === true ? <Loading /> : ""}
    </div>
  );
};

const ComponentRenderData = ({ data, onReceivechildProps }) => {
  return (
    <>
      <div className="tabs">
        <TabContext value={"1"}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList
              onChange={""}
              aria-label="lab API tabs example"
              className="UpdateStatustabsvalue"
            >
              <Tab label="Bulk upload Results" value="1" />
            </TabList>
          </Box>
          <TabPanel value="1">
            {data && (
              <div>
                <div className="jobsdatacss">
                  <tr>
                    <td>Total Resumes</td>
                    <td>:</td>
                    <td>{data.totalResume}</td>
                  </tr>
                </div>
                <br />
                <Divider className="secline" />
                <p>
                  Your documents have been submitted for offline processing.
                  Once the process is complete, you will receive a confirmation
                  email and Please refresh the page.
                </p>
                {data?.data?.map((msg) => {
                  return (
                    <ul>
                      <li
                        style={{ textAlign: "left" }}
                        dangerouslySetInnerHTML={{ __html: msg }}
                      ></li>
                    </ul>
                  );
                })}
              </div>
            )}
          </TabPanel>
        </TabContext>
      </div>
    </>
  );
};

export default TableApplicants;

/// for dynamic Table config Object
const configuration = {
  isSearchbar: true,
  isPaging: true,
  isDropdownActions: false,
  isCheckbox: true,
  isActions: true,
  recordperPage: 1,
  currentPage: 1,
  totalRecords: 0,
  isTotalCount: true,
  totalRecordsCount: 0,
  totalRecordsCountText: "Total Applicants",
  limitData: 20,
  isCheckAlignRight: true,
  isPaginationTop: true,
  isSearchServer: true,
  isPagingServer: true,
  isPageRange: true,
};

// for dynamic Table Action dropdownData
const actionsDropdownData = ["Delete", "Send SMS", "Add to Project"];

// for dynamic Table row Action buttons
const actionsList = {
  isDownload: false,
  isDelete: true,
};

// for dynamic Table Headers and columns
const columnsData = [
  {
    id: 1,
    displayName: "Applicant Code",
    type: "Applicant Code",
    mappingName: "applicantCode",
    theadClass: "dynatableheadtext text-center",
    tbodyClass: "dynatablebodytext text-center",
    width: "",
    isEdit: true,
    nagigate: "/ats/layout/applicants/view",
    openNewTab: true,
  },
  {
    id: 2,
    displayName: "Applicant Name",
    type: "Applicant Code",
    mappingName: "ApplicantName",
    theadClass: "dynatableheadtext text-center ",
    tbodyClass: "dynatablebodytext  text-center NameCapitalise",
    width: "",
    isEdit: true,
    nagigate: "/ats/layout/applicants/view",
  },
  {
    id: 3,
    displayName: "Contact Number",
    type: "Applicant Code",
    mappingName: "contactNumber",
    theadClass: "dynatableheadtext text-center  ",
    tbodyClass: "dynatablebodytext text-center",
    width: "",
    isEdit: true,
    nagigate: "/ats/layout/applicants/view",
  },
  {
    id: 4,
    displayName: "E-mail ID",
    type: "Applicant Code",
    mappingName: "emailId",
    theadClass: "dynatableheadtext text-center",
    tbodyClass: "dynatablebodytextemail text-center",
    width: "",
    isEdit: true,
    nagigate: "/ats/layout/applicants/view",
  },
  {
    id: 5,
    displayName: "Created By",
    type: "Applicant Code",
    mappingName: "createdBy",
    theadClass: "dynatableheadtext text-center ",
    tbodyClass: "dynatablebodytext text-center",
    width: "",
    isEdit: true,
    nagigate: "/ats/layout/applicants/view",
  },
];

const pannelobj1 = {
  title: "Add New Applicant",
  description: "",
  bgImage: "",
};

const pannelobj2 = {
  title: "Add New Applicant",
  description: "",
  bgImage: "",
};

const bulkResponseObj = {
  title: "Bulk Upload",
  description: "",
  bgImage: ``,
};

const smsObj = {
  title: "Send SMS",
  description: "",
  bgImage: "", // `${process.env.PUBLIC_URL}/assests/img/emailbackground.svg`,
};

const addToProjectObj = {
  title: "Add to Project",
  description: "",
  bgImage: "",
};

export const advanceSearchModel = [
  {
    id: 1,
    displayName: "Skills",
    name: "skills",
    isActive: false,
    type: "multiselect",
    helperText:
      "Add one or more skills. Multiple entries are combined with AND (candidates must have all skills)",
  },
  {
    id: 2,
    displayName: "Job Title",
    name: "jobtitle",
    isActive: false,
    type: "multiselect",
    helperText:
      "Enter one or more job titles. Multiple entries are combined with OR (candidates can match any title)",
  },
  {
    id: 3,
    displayName: "Experience",
    name: "experience",
    isActive: false,
    type: "rangeText",
    helperText: "Filter candidates by years of experience. Example: 3–5 years",
  },
  {
    id: 4,
    displayName: "Location",
    name: "location",
    isActive: false,
    type: "locationRange",
    helperText:
      "Search by city, state, or country. Multiple locations can be entered, separated by commas",
  },
  {
    id: 5,
    displayName: "Keyword",
    name: "keyword",
    isActive: false,
    type: "text",
    helperText:
      "Enter keywords to search across resumes and profiles. Use quotes for exact phrases",
  },
  {
    id: 6,
    displayName: "Boolean Search",
    name: "boolean",
    isActive: false,
    type: "text",
    helperText:
      "Use Boolean operators (AND, OR, NOT) for complex searches. Example: Java AND Spring NOT Python",
  },
  {
    id: 7,
    displayName: "Recruiter",
    name: "recruiter",
    isActive: false,
    type: "autoCompleteSingle",
    helperText: "Shows applicants uploaded by the selected recruiter",
  },
  // { id: 3, displayName: "Location", name: "location", isActive: false, type: "text" },
  // { id: 4, displayName: ""State", name: 'state', isActive: false, type: "text" },
  // { id: 5, displayName: ""City/Zip Code", name: "zip", isActive: false, type: "text" },
  // { id: 6, displayName: ""Job Status", name: "jobstatus", isActive: false, type: "options" },
  // { id: 7, displayName: ""Work Model", name: "workmodel", isActive: false, type: "options" },
  // { id: 8, displayName: ""Client", name: "client", isActive: false, type: "options" },
];

export const candidateStatusValues = [
  "New",
  "Associated",
  "Consent await",
  "Submitted",
  "Interview",
  "Selected",
  "Rejected",
  "Pending",
];

export const workModelModel = [
  { id: 1, name: "All", isActive: false },
  { id: 2, name: "On-site", isActive: "false" },
  { id: 3, name: "Contract", isActive: "false" },
  { id: 4, name: "Internship", isActive: "false" },
  { id: 5, name: "Fulltime", isActive: "false" },
];

export const jobStatusModel = [
  { id: 1, name: "All", isActive: false },
  { id: 2, name: "PartTime", isActive: "false" },
  { id: 3, name: "Contract", isActive: "false" },
  { id: 4, name: "Internship", isActive: "false" },
  { id: 5, name: "Fulltime", isActive: "false" },
];

export const clientsModel = [
  { id: 1, name: "ABC", isActive: false },
  { id: 1, name: "BCD", isActive: false },
];

export const searchParam = {
  keyword: [""],
  jobTitle: "",
  location: "",
  state: "",
  zipCode: "",
  jobStatus: [""],
  workModel: [""],
  client: [""],
  candidateStatus: [""],
};
